export default __webpack_public_path__ + "static/media/flower.5e9ee465.png";